import { Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "./pages/LoginPage.tsx";
import MainLayout from "./pages/MainLayout.tsx";
import Introduction from "./pages/Introduction.tsx";
import Actions from "./pages/Actions.tsx";
import Contacts from "./pages/Contacts.tsx";
import ProtectedRoute from "./components/ProtectedRoute";
import { useEffect } from "react";
import { setNotificationHandler } from "./api/axios";
import { useNotification } from "./context/NotificationContext";
import Photos from "./pages/Photos.tsx";
import ActionDetail from "./pages/ActionDetail.tsx";
import ActionEdit from "./pages/ActionEdit.tsx";
import ParticipantEdit from "./pages/ParticipantEdit.tsx";
import PhotoDetail from "./pages/PhotoDetail.tsx";

const App = () => {
  const { showNotification } = useNotification();

  useEffect(() => {
    setNotificationHandler((message: string) => {
      showNotification(message, "error");
      console.log(message);
    });
  }, [showNotification]);

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      <Route
        path="/"
        element={
          <ProtectedRoute>
            <MainLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Introduction />} />
        <Route path="actions/list/:isplanned" element={<Actions />} />
        <Route path="actions/:id" element={<ActionDetail />} />
        <Route path="actions/:id/edit" element={<ActionEdit />} />
        <Route path="participant/:id/edit/:idaction" element={<ParticipantEdit />} />
        <Route path="photos/:year/:set" element={<Photos />} />
        <Route path="photos/detail/:year/:set/:position" element={<PhotoDetail />} />
        <Route path="contacts" element={<Contacts />} />
      </Route>

      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};

export default App;